import {
  defaultRelationFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  ParkingSpotConfig,
  ParkingSpotContractConfig,
} from '@pigello/pigello-matrix';
import baseFilters, {
  baseGlobalRealEstatesFilter,
  baseTagFilter,
} from '../../filters';
import baseContractFilters from '../components/base-contract-filters';
import { Icons } from '@/components/icons';

const parkingSpotContractFilters: Filter[] = [
  {
    ...defaultRelationFilter,
    title: ParkingSpotContractConfig.fields.space.verboseName,
    relationModelName: ParkingSpotConfig.modelName,
    externalFieldName: ParkingSpotContractConfig.fields.space.externalFieldName,
    icon: Icons.parkingspot,
  },
  ...baseGlobalRealEstatesFilter,
  ...baseContractFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default parkingSpotContractFilters;
